import React from 'react';
import SignupForm from '../components/SignupForm'; // Import the SignupForm component

const SignupPage = () => {

  const handleSignup = (formData) => {
    // Handle successful signup
    console.log("User signed up with the following data:", formData);
    // You can add any additional logic after signup, like redirecting the user
  };

  return (
    <div>
      <SignupForm onSignup={handleSignup} />
    </div>
  );
};

export default SignupPage;
